// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"f8956833","488":"6829facd","603":"15816009","945":"ca41b4b2"}[chunkId] + ".chunk.js";
};